import { SET_INVALID_FIELDS } from './actions';

export default function(state = [], action) {
  switch (action.type) {

  case SET_INVALID_FIELDS:
    return Object.keys(action.fields).filter(name => !action.fields[name].hidden);
  default:
    return state;
  }
}